import React from "react";
import {
  Box,
  Stack,
  Typography,
  Switch,
} from "@mui/material";
import ApartmentIcon from "@mui/icons-material/Apartment";

/**
 * ParkingHeader – React + MUI
 */
export function ParkingHeader({ isEnabled, onToggle }) {
  return (
    <Box
      display="flex"
      flexDirection={{ xs: "column", sm: "row" }}
      alignItems={{ sm: "center" }}
      justifyContent="space-between"
      gap={2}
    >
      {/* Left section */}
      <Stack direction="row" spacing={2} alignItems="center">
        <Box
          width={40}
          height={40}
          display="flex"
          alignItems="center"
          justifyContent="center"
          borderRadius={2}
          bgcolor="primary.50"
        >
          <ApartmentIcon color="primary" />
        </Box>

        <Box>
          <Typography variant="h6" fontWeight={600}>
            Parking Configuration
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
          >
            Configure parking options for each wing and unit type
          </Typography>
        </Box>
      </Stack>

      {/* Right section */}
      <Stack
        direction="row"
        spacing={1.5}
        alignItems="center"
        alignSelf={{ xs: "flex-end", sm: "auto" }}
      >
        <Typography
          variant="body2"
          color="text.secondary"
          fontWeight={500}
        >
          {isEnabled ? "Enabled" : "Disabled"}
        </Typography>

        <Switch
          checked={isEnabled}
          onChange={(e) => onToggle(e.target.checked)}
          color="primary"
        />
      </Stack>
    </Box>
  );
}
